import enTranslations from '../assets/i18n/en.json';

/** User-facing strings for the pre-bootstrap region picker (same keys as Transloco after bootstrap). */
export interface RegionPickerCopy {
  /** Accessible name for the dTIMS wordmark above the heading. */
  readonly logoAlt: string;

  /** Page heading (`h1`). */
  readonly title: string;

  /** Introductory paragraph under the heading. */
  readonly hint: string;

  /** `fieldset` legend for the region option buttons (visually hidden). */
  readonly optionsLegend: string;

  /** Visible label on the time-zone suggested region button. */
  readonly suggestedLabel: string;

  /** `document.title` while the picker is shown (suffix ` – dTIMS` is appended in code). */
  readonly documentTitle: string;

  /** Heading when bootstrap fails before Angular loads. */
  readonly bootErrorTitle: string;

  /** Action on the boot-error screen to clear the saved region and reopen the picker. */
  readonly backToRegionSelection: string;
}

/** English copy from `en.json` key `regionPicker` (Transloco scope `shellApp` → `shellApp.regionPicker`). */
export const REGION_PICKER_COPY: RegionPickerCopy = enTranslations.regionPicker;
